import { parsePhoneNumber } from "react-phone-number-input";

export const formatE164 = value => {
	if (!value) return "";

	return parsePhoneNumber(value)?.format("E.164");
};